module.exports = __webpack_public_path__ + "img/FinTurno-usuario.55a84935.png";